export type OnboardingPlacement =
  | "top"
  | "bottom"
  | "left"
  | "right"
  | "center";

export interface OnboardingStep {
  // Sélecteur CSS de l'élément à mettre en évidence.
  // Absent pour une étape centrée (ex: message de bienvenue).
  target?: string;
  title: string;
  content: string;
  placement?: OnboardingPlacement;
}

export type OnboardingTourId = "home" | "stressors" | "profile" | "impacts";

export const onboardingTours: Record<OnboardingTourId, OnboardingStep[]> = {
  home: [
    {
      title: "Welcome to the CRDB Climate Risk Assessment tool",
      content:
        "This platform helps you assess climate-related risks for your agricultural lending portfolio. Let's take a quick tour to get you started.",
      placement: "center",
    },
    {
      target: '[data-tour="explore-data"]',
      title: "Explore your data",
      content:
        'Click "EXPLORE DATA" to enter the Data Room and browse every climate analysis module.',
      placement: "top",
    },
    {
      target: '[data-tour="nav-data-room"]',
      title: "Data Room",
      content:
        "You can also reopen the Data Room at any time from the top navigation bar.",
      placement: "bottom",
    },
    {
      target: '[data-tour="nav-risk"]',
      title: "Risk Assessment",
      content:
        "Run a Climate Risk Assessment to get data-driven insights for your lending decisions.",
      placement: "bottom",
    },
  ],
  stressors: [
    {
      title: "Climate Stressors",
      content:
        "Explore climate risk indicators such as flooding, drought and heat stress across Tanzania.",
      placement: "center",
    },
    {
      target: '[data-tour="stressors-sidebar"]',
      title: "Analysis filters",
      content:
        "Use these filters to select the risk type, plot type, period and zone of interest.",
      placement: "right",
    },
    {
      target: '[data-tour="stressors-content"]',
      title: "Spatial & time analysis",
      content:
        "Visualize the selected indicator on the map, or switch to time view. Click on a zone to analyze it.",
      placement: "top",
    },
  ],
  profile: [
    {
      title: "Climate Profile",
      content:
        "Analyze temperature and precipitation projections for any Tanzanian region.",
      placement: "center",
    },
    {
      target: '[data-tour="profile-filters"]',
      title: "Analysis filters",
      content:
        "Choose the plot type, variable, period, season and zone to build your analysis.",
      placement: "bottom",
    },
    {
      target: '[data-tour="profile-content"]',
      title: "Results",
      content:
        "Explore the climate projections on the map or as time series for the selected zone.",
      placement: "top",
    },
  ],
  impacts: [
    {
      title: "CROPS PRODUCTION",
      content:
        "Analyze how climate change affects crop yields and water demand across Tanzania.",
      placement: "center",
    },
    {
      target: '[data-tour="impacts-filters"]',
      title: "Analysis filters",
      content:
        "Select the crop, product, data type, period and zone of interest.",
      placement: "bottom",
    },
    {
      target: '[data-tour="impacts-content"]',
      title: "Results",
      content:
        "Visualize the yield gap or crop water demand on the map, or switch to time view.",
      placement: "top",
    },
  ],
};

// Mapping des routes vers le tour correspondant.
export const routeTourMap: Record<string, OnboardingTourId> = {
  "/": "home",
  "/home": "home",
  "/dashboard/stressors": "stressors",
  "/dashboard/profile": "profile",
  "/dashboard/impacts": "impacts",
};

export const defaultTourId: OnboardingTourId = "home";
